// 運営事務局 : ban thư ký vận hành
// TEL : te le phôn
// 発送 : vận chuyển
// デザイン : thiết kế
// 印刷 : in ấn
// 賞品発送 : vận chuyển phần thưởng
// SNS投稿 : đăng lên mạng xã hội

const formPrize = {
    client: null,
    digital_gifts: {},
    type: {
        id: ''
    },
    coupon_value: '',
    name: '',
    quantity: '',
    number_of_win_prize: '',
    scheduled_arrived_at: '',
    scheduled_arrived_at_y: '',
    scheduled_arrived_at_m: '',
    scheduled_arrived_at_d: '',
    expiration_date: '',
    expiration_date_y: '',
    expiration_date_m: '',
    expiration_date_d: '',
    warehousing_date: '',
    warehousing_date_y: '',
    warehousing_date_m: '',
    warehousing_date_d: '',
    warehousing_quantity: '',
    shipment_quantity: '',
    remaining_quantity: '',
    delivery_company: '',
    is_packaging_photo_required: '1'
};

const formPrizeRegister = {
    digital_gifts: {},
    type: {
        id: ''
    },
    campaign: {
        id: ''
    },
    name: '',
    title: '',
    quantity: '',
    is_packaging_photo_required: false,
    number_of_win_prize: '',
    scheduled_arrived_at: '',
    scheduled_arrived_at_y: '',
    scheduled_arrived_at_m: '',
    scheduled_arrived_at_d: '',
    expiration_date: '',
    expiration_date_y: '',
    expiration_date_m: '',
    expiration_date_d: '',
    warehousing_date: '',
    warehousing_date_y: '',
    warehousing_date_m: '',
    warehousing_date_d: '',
    warehousing_quantity: '',
    shipment_quantity: '',
    remaining_quantity: '',
    delivery_company: ''
};

const formCampaign = {
    campaign_url: null,
    source_data: {
        type: '',
        id: ''
    },
    total_number_of_win_prize: '',
    application_date: '',
    name: '',
    progress_status: '',

    campaign_start_date: '',
    campaign_start_time: '',

    campaign_end_date: '',
    campaign_end_time: '',

    secretariat_start_date: '',
    secretariat_start_time: '',

    secretariat_end_date: '',
    secretariat_end_time: '',

    receipt_expiration_start_date: '',
    receipt_expiration_start_time: '',
    receipt_expiration_end_date: '',
    receipt_expiration_end_time: '',

    configCampaignStartDateTime: { minuteStep: 1, placeholderTime: '', errorDateTimeStartCampaign: '', error: false },
    configCampaignEndDateTime: { minuteStep: 1, placeholderTime: '', errorDateTimeEndCampaign: '', error: false },
    configSecretariatStartDateTime: { minuteStep: 1, placeholderTime: '', errorDateTimeStartSecretariat: '', error: false, timeDefault: '10:00' },
    configSecretariatEndDateTime: { minuteStep: 1, placeholderTime: '', errorDateTimeEndSecretariat: '', error: false, timeDefault: '17:00' },
    configReceiptExpirationStartDateTime: {
        minuteStep: 1,
        placeholderTime: '',
        errorText: '',
        error: false
    },
    configReceiptExpirationEndDateTime: {
        minuteStep: 1,
        placeholderTime: '',
        errorText: '',
        error: false
    },

    url_publish_time_from: '',
    url_publish_time_from_time: '',

    url_publish_time_to: '',
    url_publish_time_to_time: '',

    configUrlPublishTimeFrom: {
        minuteStep: 1,
        placeholderTime: '',
        errorText: '',
        error: false
    },
    configUrlPublishTimeTo: {
        minuteStep: 1,
        placeholderTime: '',
        errorText: '',
        error: false
    },

    campaign_type: {
        id: null,
        key: '',
        value: ''
    },
    types: [],
    hashtag: [],
    inform: '',
    content_projects: [],
    target_product_lists: [],
    listCheckedTargetLv1: [],
    listCheckedTargetLv2: [],
    purchase_conditions: [],
    contact_informations: [],
    tool_useds: [],
    url: '',

    application_method: '',
    lottery_number_of_winners: '',
    prize_shipping_period: '',
    prize_shipping_period_type: '',
    inquiry_office: '',
    sale_staff: {
        id: ''
    },
    team: {
        id: ''
    },
    person_in_charge: {
        id: ''
    },
    responsible_sub_persons: [],
    part_time_employees: [],
    partners: [],
    agencies: [],
    clients: [],
    templates: [],
    prizes: [],
    keywords: [],
    sns_collections_tool: [],
    campaign_sns_collections_tools: [],
    application_condition_1: {
        id: ''
    },
    application_condition_2: {
        id: ''
    },
    sns_application_condition_1: {
        id: ''
    },
    sns_application_condition_2: {
        id: ''
    },
    purchase_condition_2: {
        id: ''
    },
    number_of_sns_followers: '',
    free_word: '',
    give_away: 0,
    give_away_information: {
        inflow_destination: '',
        inflow_rate: '',
        attrition_rate: ''
    },
    advertising_result: '',
    advertising_cost: '',
    advertising_media: '',
    line_friends_growth: '',
    sns_winners_without_registration_rate: '',
    defects_in_cash_back_applicants_rate: '',
    categories: [],
    phone_pic: null,
    customer_team_pic: null,
    chat_rooms: [
        {
            room_id: '',
            room_name: ''
        }
    ],
    zac_id: '',
    isShowPublicTime: false,
    isShowReceiptExpirationDate: false,
    isShowConditionBuyAndSell: false,
    isShowPostcardDate: false,
    event_prizes: [],
    project_management: null,
    campaign_master_order_scopes: [],
    campaign_master_order_scope_partner: [],
    has_tel_phone_setting: false,
    customer_sub_person: [],
    associated_campaign: null,
    sfid: '',
    information_ips: [],
    folder_project: '',
    folder_quotation: '',
    campaign_entity_id: '',
    sponsor_informations: [],
    number_of_applications: [],
    total_number_of_applications: 0,
    number_of_inquiries: [],
    total_number_of_inquiries: 0,
    platform_followers_number: [],
    advertising_activity: null,
    social_platforms: [],
    give_away_related: null,
    account_infor_on_screen: '',
    pdca_file_report: null,
    cashback_file_report: null,
    is_post_effective_date: false,
    is_before_due_date: false,
    client_generate_file: '',
    campaign_content_other: {
        overview_information: '',
        period_related: '',
        application_details: '',
        product_related: '',
        announcement_site_related: '',
        prizes_and_winning_information: '',
        inquiries: '',
        folder_chat_related: '',
        others: ''
    }
};

const formPartner = {
    department: '',
    keywords: [],
    name: '',
    kana_name: '',
    email: '',
    phone_number: '',
    types: [],
    note: '',
    province: '',
    address_1: '',
    address_2: '',
    url: '',
    postal_code: '',
    keyword: '',
    namePic: '',
    emailPic: '',
    passwordPic: ''
};

const formClient = {
    department: '',
    email: '',
    keywords: [],
    name: '',
    kana_name: '',
    phone_number: '',
    profile: '',
    address_1: '',
    address_2: '',
    url: '',
    postal_code: '',
    province: '',
    namePic: '',
    type_id: null,
    corp_number: ''
};

const listContactInformations = [
    {
        id: 2,
        text: 'TEL',
        subText: '電話番号（確定）',
        configInput: {
            isNumber: false,
            isConvertHalfsize: true,
            maxlength: 15,
            isMaxLength: false,
            error: false,
            errorField: '電話番号（確定）',
            typesValidate: ['number-hyphens']
        }
    },
    {
        id: 5,
        text: 'メール',
        subText: 'メールアドレス',
        configInput: {
            isEmail: false,
            isMaxLength: false,
            error: false,
            errorField: 'メールアドレス'
        }
    },
    {
        id: 8,
        text: 'DM',
        subText: 'DM対応アカウント',
        child: [
            {
                id: 9,
                text: 'X',
                subText: 'DM対応アカウント',
                configInput: {
                    isMaxLength: false,
                    error: false,
                    errorField: 'X'
                }
            },
            {
                id: 10,
                text: 'Instagram',
                subText: 'DM対応アカウント',
                configInput: {
                    isMaxLength: false,
                    error: false,
                    errorField: 'Instagram'
                }
            },
            {
                id: 11,
                text: 'TikTok',
                subText: 'DM対応アカウント',
                configInput: {
                    isMaxLength: false,
                    error: false,
                    errorField: 'TikTok'
                }
            },
            {
                id: 12,
                text: 'LINE',
                subText: 'DM対応アカウント',
                configInput: {
                    isMaxLength: false,
                    error: false,
                    errorField: 'LINE'
                }
            }
        ]
    },
    {
        id: 13,
        text: 'その他',
        subText: 'その他',
        configInput: {
            isMaxLength: false,
            error: false,
            errorField: 'その他'
        }
    }
];

const campaignStatus = [
    {
        id: 1,
        text: 'ほぼ確',
        backgroundColor: '#ffff0040'
    },
    {
        id: 2,
        text: '確定',
        backgroundColor: '#ffa50073'
    },
    {
        id: 3,
        text: '進行中',
        backgroundColor: '#ff00006b'
    },
    {
        id: 4,
        text: '終了',
        backgroundColor: '#80808066'
    },
    {
        id: 5,
        text: '廃棄待ち',
        backgroundColor: '#4aa3ffa1'
    },
    {
        id: 6,
        text: '失注',
        backgroundColor: '#80808094'
    }
];

const numberOfApplications = {
    total: '',
    postcard_mail: '',
    web: '',
    palnavi: '',
    sns: '',
    twitter: '',
    instagram: '',
    line: '',
    others: '',
    invalid: ''
};

const numberOfInquiries = {
    total: '',
    tel: '',
    email: '',
    number_of_cases: '',
    irregular: '',
    irregular_content: ''
};

const TITLE_PLATFORM = [
    {
        id: 1,
        title: '《PF_Twitter》',
        pf_title: 'PF_TWITTER'
    },
    {
        id: 2,
        title: '《PF_WEB(レシート)》',
        pf_title: 'PF_WEB'
    },
    {
        id: 3,
        title: '《PF_LINE(CRサポーター)》',
        pf_title: 'PF_LINE'
    },
    {
        id: 4,
        title: '《PF_Instagram》',
        pf_title: 'PF_INSTAGRAM'
    },
    {
        id: 5,
        title: '《PF_ハガキ》',
        pf_title: 'PF_POSTCARD'
    }
];

export {
    numberOfInquiries,
    numberOfApplications,
    formPrizeRegister,
    campaignStatus,
    listContactInformations,
    formPrize,
    formClient,
    formCampaign,
    formPartner,
    TITLE_PLATFORM
};
